"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaChannelsChannelsToJSON = exports.MfaChannelsChannelsFromJSONTyped = exports.MfaChannelsChannelsFromJSON = void 0;
const _1 = require("./");
function MfaChannelsChannelsFromJSON(json) {
    return MfaChannelsChannelsFromJSONTyped(json, false);
}
exports.MfaChannelsChannelsFromJSON = MfaChannelsChannelsFromJSON;
function MfaChannelsChannelsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'channel': _1.ContactMethodFromJSON(json['channel']),
        'label': json['label'],
    };
}
exports.MfaChannelsChannelsFromJSONTyped = MfaChannelsChannelsFromJSONTyped;
function MfaChannelsChannelsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'channel': _1.ContactMethodToJSON(value.channel),
        'label': value.label,
    };
}
exports.MfaChannelsChannelsToJSON = MfaChannelsChannelsToJSON;
//# sourceMappingURL=MfaChannelsChannels.js.map